import React from 'react';
import { Tooltip } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CustomButton from '../buttons/CustomButton';
import { getDownloadParts, getDownloadUrl } from './exportJob';
import { downloadExportFile } from './exportDownload';

const ROLE_TOOLTIP = 'Apenas proprietários e administradores podem baixar exportações';

/**
 * Botão(ões) de download de uma exportação concluída: uma exportação com
 * várias partes (acima do teto por ZIP) ganha um botão por parte; caso
 * contrário, um único botão. Usado no histórico de Backup e dados e no
 * diálogo "Encerrar conta". `showLabel` escreve "Baixar" ao lado do ícone.
 * `onDownload(index)` avisa cada clique (índice da parte; 0 no arquivo
 * único) e `downloadedIndexes` marca com um check as partes já baixadas.
 */
function ExportDownloadButtons({ item, canManage = true, showLabel = false, onDownload, downloadedIndexes = [] }) {
    const parts = getDownloadParts(item);
    const download = (url, index) => {
        downloadExportFile(url);
        if (onDownload) onDownload(index);
    };
    const iconFor = (index, fallback) => (downloadedIndexes.includes(index) ? <CheckIcon fontSize="small" /> : fallback);

    if (parts.length > 1) {
        return parts.map((part, index) => (
            <Tooltip key={part.url || index} title={!canManage ? ROLE_TOOLTIP : `Baixar parte ${index + 1}`} arrow>
                <span>
                    <CustomButton
                        style="secondary"
                        label={`Parte ${index + 1}`}
                        icon={iconFor(index)}
                        onClick={() => download(part.url, index)}
                        rounded={true}
                        outlined={true}
                        disabled={!canManage}
                    />
                </span>
            </Tooltip>
        ));
    }

    const url = getDownloadUrl(item);
    if (!url) return null;

    return (
        <Tooltip title={!canManage ? ROLE_TOOLTIP : 'Baixar exportação'} arrow>
            <span>
                <CustomButton
                    style="secondary"
                    label={showLabel ? 'Baixar' : undefined}
                    icon={iconFor(0, <CloudDownloadOutlinedIcon fontSize="small" />)}
                    onClick={() => download(url, 0)}
                    rounded={true}
                    outlined={true}
                    disabled={!canManage}
                />
            </span>
        </Tooltip>
    );
}

export default ExportDownloadButtons;
